module.exports = __webpack_public_path__ + "img/main-visual-02.db1e189f.jpeg";